module.exports = __webpack_public_path__ + "assets/img/help_tj7.e28ba649.png";